import { render, staticRenderFns } from "./TourSummary.vue?vue&type=template&id=667f1247&scoped=true&"
import script from "./TourSummary.vue?vue&type=script&lang=js&"
export * from "./TourSummary.vue?vue&type=script&lang=js&"
import style0 from "./TourSummary.vue?vue&type=style&index=0&id=667f1247&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f1247",
  null
  
)

export default component.exports